import React from 'react';
import { Box, Flex, Heading } from '@qga/roo-ui/components';
import { Flag } from '../../../primitives';
import OfferInclusions from 'components/OfferInclusions';
import { useBreakpoints } from 'hooks/useBreakpoints';
import type { Offer } from 'types/property';
import { INCLUSIONS_ICONS_PREVIEW } from 'config/constants';

interface OfferDescriptionProps {
  offerName: Offer['name'];
  inclusions: Offer['inclusions'];
  isExpanded?: boolean;
  onClick: () => void;
}

export const OfferDescription = ({ offerName, inclusions, onClick }: OfferDescriptionProps) => {
  const { isLessThanBreakpoint } = useBreakpoints();
  const isMobile = isLessThanBreakpoint(0);

  const previewIconsMobile = inclusions?.slice(0, INCLUSIONS_ICONS_PREVIEW);

  return (
    <Flex mb={[4, 4]} data-testid="extra-flex-inclusions" flexDirection="column" width={['100%', '50%', '50%']} justifyContent="flex-start">
      <Flex justifyContent={isMobile ? 'space-between' : 'flex-start'}>
        <Heading.h3 mb={[0, 0]} fontSize="md" lineHeight="normal" color="greys.charcoal">
          {offerName}
        </Heading.h3>
      </Flex>
      <Box color="greys.charcoal">
        {!isMobile && (
          <Flex flexDirection="column" data-testid="inclusions-preview-wrapper-desktop">
            <OfferInclusions inclusions={inclusions} onClick={onClick} isToggleExpansion={true} />
          </Flex>
        )}
        <Flex flexDirection="row" data-testid="inclusions-preview-wrapper-mobile">
          {isMobile &&
            previewIconsMobile?.map(({ code, icon }) => (
              <Box pb={2} key={code}>
                <Flag icon={icon} color="greys.charcoal" />
              </Box>
            ))}
        </Flex>
      </Box>
    </Flex>
  );
};
